import { useContext, useEffect, useState } from 'react';
import { CartContext } from 'context-providers/cart-provider';
import { activeMiniSale } from 'lib/mini-sale/mini-sale';

type ActiveMiniSale = ReturnType<typeof activeMiniSale>;

/**
 * Returns the active mini-sale, but only after the component has mounted on the
 * client. The sale window is time-based, so evaluating it during SSR/SSG (or on
 * the first client render) would diverge from the static HTML and cause a
 * hydration mismatch. Returning null until mount keeps server and client markup
 * identical, then reveals the sale UI on the next paint.
 */
export const useActiveMiniSale = (): ActiveMiniSale => {
  const [miniSale, setMiniSale] = useState<ActiveMiniSale>(null);
  const { promoCode } = useContext(CartContext);

  useEffect(() => {
    setMiniSale(activeMiniSale(promoCode || undefined));
  }, [promoCode]);

  return miniSale;
};
